import { useCallback } from 'react';
import { setIsAuthenticated } from '../../redux/actions/billing';
import { setDeviceAuthRedirectURL } from '../../redux/actions/device-auth';
import { getIsActivatingDevice } from '../../redux/selectors/device-auth';
import useStartDeviceActivation from '../device-auth/use-start-device-activation';
import useRedirectToPlayer from '../router/use-redirect-to-player';
import useAppStore from '../use-app-store';

/** KU
 *
 * Returns a handler, {@link handleRedirectAfterAuthFlowComplete}, which handles
 * redirecting the user after an auth flow (e.g., signup, sign-in) is complete.
 * If the user was attempting to activate a Smart TV before they entered the
 * auth flow, {@link handleRedirectAfterAuthFlowComplete} will start the device
 * activation process (via {@link handleStartDeviceActivation}). Otherwise, it
 * simply redirects the user to `/player` (via {@link handleRedirectToPlayer}).
 *
 */
export default function useRedirectAfterAuthFlowComplete() {
  const { dispatch, getState } = useAppStore();

  const { handleStartDeviceActivation } = useStartDeviceActivation();
  const { handleRedirectToPlayer } = useRedirectToPlayer();

  const handleRedirectAfterAuthFlowComplete = useCallback((redirectURL?: string) => {
    const state = getState();
    const isActivatingDevice = getIsActivatingDevice(state);
    dispatch(setIsAuthenticated(true));
    if (isActivatingDevice) {
      dispatch(setDeviceAuthRedirectURL(redirectURL));
      handleStartDeviceActivation();
    } else {
      handleRedirectToPlayer(redirectURL);
    }
  }, []);

  return { handleRedirectAfterAuthFlowComplete };
}
